<template>
    <transition name="slide-fade">
        <div class="modal" :class="{ 'open': open }" v-if="open" data-cy="modal_serial_modal">
            <div class="modal-content">
                <div class="bg-white w-full rounded-5px" v-if="serialModel != null" data-cy="container_serial_modal_content">
                    <SerialDetail :serialModel="serialModel" data-cy="component_serial_modal_detail"></SerialDetail>
                    <Serial :serialModel="serialModel" ref="serial" data-cy="component_serial_modal_serial"></Serial>
                    <SerialTimer :serialModel="serialModel" @onSerialExpired="onSerialExpired()" data-cy="component_serial_modal_timer"></SerialTimer>
                    <SerialAvailableInfo data-cy="component_serial_modal_available_info"></SerialAvailableInfo>
                    <div class="text-center p-3">
                        <img src="@/assets/imgs/logo/bzbs.svg" class="mx-auto" data-cy="img_serial_modal_logo" />
                    </div>
                    <MarkUsed @onClick="onClickMarkUsed()" v-if="!serialModel.isUsed" data-cy="component_serial_modal_mark_used"></MarkUsed>
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open" data-cy="container_serial_modal_backdrop"></div>
    </transition>
</template>
<script>
import mitt from "mitt"
import { computed as vueComputed } from "vue"

import Util from "@/helper/Utility.js";
import DatetimeHelper from "@/helper/DatetimeHelper.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
//component
import SerialDetail from "./component/SerialDetail.vue";
import Serial from "./component/Serial.vue";
// import PrivilegeMessage from "./component/PrivilegeMessage.vue";
import SerialTimer from "./component/SerialTimer.vue";
import SerialAvailableInfo from "./component/SerialAvailableInfo.vue";
import MarkUsed from "./component/MarkUsed.vue";

export default {
    name: "SerialModal",
    mixins: [LocaleMixin],
    components: {
        SerialDetail,
        Serial,
        // PrivilegeMessage,
        SerialTimer,
        SerialAvailableInfo,
        MarkUsed,
    },
    props: {
        controller: Object,
    },
    provide: function () {
        return {
            eventBus: this.eventBus,
            model: vueComputed(() => this.serialModel)
        }
    },
    data: function () {
        return {
            open: false,
            busModal: null,

            serialModel: null,
            eventBus: new mitt()
        };
    },
    created: function () {
        this.busModal = this.controller.busModal;
        this.eventBus.on("clickClose", this.clickClose)
    },
    mounted: function () {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    beforeUnmount: function () {
        this.eventBus.off("clickClose")
    },
    methods: {
        show: function (config) {
            this.serialModel = config.serialModel; 
            console.log("SerialModal show", this.serialModel);

            document.body.classList.add('not-scroll');
            this.open = true;
        },
        hide: function () {
            document.body.classList.remove('not-scroll');
            this.open = false;
        },
        clickClose: function () {
            this.hide();
            this.controller.sendCloseModal();
        },

        getRedeemMessage: function () {
            let dateStr = DatetimeHelper.getDatetimeFullFormat(this.serialModel.redeemTimestamp);
            return Util.stringFormat(this.lbl.serial.redeem_on, dateStr);
        },

        onSerialExpired: function () {
            // this.$refs['serial'].setSerialExpire();
            // this.controller.sendSerialExpire();
        },
        onClickMarkUsed: function () { 
            this.controller.sendClickMarkUsedModal();
        }, 
        
    },
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "@/style/modal.scss";

.modal {
    @extend %modal;

    .modal-content {
        overflow: unset;
        width: 420px;

        @include mobile {
            width: 100%;
            padding: 16px;
        }
    }
}
</style>
